import { render, staticRenderFns } from "./crkStatistics.vue?vue&type=template&id=35d22330&scoped=true"
import script from "./crkStatistics.vue?vue&type=script&lang=js"
export * from "./crkStatistics.vue?vue&type=script&lang=js"
import style0 from "./crkStatistics.vue?vue&type=style&index=0&id=35d22330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d22330",
  null
  
)

export default component.exports